import { CurvedEdge } from './CurvedEdge';
import { StraightEdge } from './StraightEdge';

export const workflowEdgeTypes = {
  curved: CurvedEdge,
  straight: StraightEdge,
  // Note: 'default', 'smoothstep', and 'step' are built-in ReactFlow edge types
  // We'll use the built-in ones for smoothstep and step
};

export { CurvedEdge, StraightEdge };
